module.exports = __webpack_public_path__ + "img/opay-logo.9fd82078.png";